/**
 * The possible article status.
 */
export enum ArticleStatus {
  Available = 'Available',
  Discontinued = 'Discontinued',
}
